import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from '@appkit4/angular-components/checkbox';
import { FieldModule } from '@appkit4/angular-components/field';
import { ModalModule } from '@appkit4/angular-components/modal';
import { TabsModule } from '@appkit4/angular-components/tabs';

import { SearchModule } from '@appkit4/angular-components/search';
import { GridModule } from '@shared/modules/grid/grid.module';
import { PrimeGridFiltersModule } from '@shared/modules/prime-grid-filters/prime-grid-filters.module';
import { RichEditorModule } from '@shared/modules/rich-editor/rich-editor.module';
import { SharedModule } from '@shared/shared.module';
import { AdminRoutingModule } from './admin-routing.module';
import {
  ClientsGridComponent,
  EntityTypesGridComponent,
  ExternalUsersGridComponent,
  GeneralRatesRuleEngineGridComponent,
  InternalUsersGridComponent,
  InvestmentJurisdictionsGridComponent,
  ResidencyJurisdictionsGridComponent,
  SecurityTypesGridComponent,
  UpsertClientComponent,
  UpsertEntityTypeComponent,
  UpsertExternalUserComponent,
  UpsertGeneralRatesRuleEngineComponent,
  UpsertInternalUserComponent,
  UpsertInvestmentJurisdictionComponent,
  UpsertResidencyJurisdictionComponent,
  UpsertSecurityTypeComponent,
} from './components';
import { AdminPrimeGridComponent } from './components/admin-prime-grid/admin-prime-grid.component';
import { AssignClientComponent } from './components/assign-client/assign-client.component';
import { AssignCountryMaterialComponent } from './components/assign-country-material/assign-country-material.component';
import { AdminExplanationEditorComponent } from './components/explanation-editor/explanation-editor.component';
import { ExportCountriesInformationModalComponent } from './components/export-countries-information-modal/export-countries-information-modal.component';
import { ExportTaxRatesValuesModalComponent } from './components/export-tax-rates-values-modal/export-tax-rates-values-modal.component';
import { TransactionTypeCellComponent } from './components/transaction-type-cell/transaction-type-cell.component';
import { UserEngagementsCellComponent } from './components/user-engagements-cell/user-engagements-cell.component';
import { UserEngagementsDrawerComponent } from './components/user-engagements-drawer/user-engagements-drawer.component';
import {
  AdminDashboardPageComponent,
  AdminTabsPageComponent,
  ClientsPageComponent,
  EntityTypesPageComponent,
  ExternalUsersPageComponent,
  GeneralRatesRuleEnginePageComponent,
  InternalUsersPageComponent,
  InvestmentJurisdictionsPageComponent,
  ResidencyJurisdictionsPageComponent,
  SecurityTypesPageComponent,
  UsersPageComponent,
} from './pages';
import { RulesManagerPageComponent } from './pages/rules-manager-page/rules-manager-page.component';
import { TaxPoliciesManagerService } from './services/tax-policies-manager.service';
import { TaxRulesManagerHeadersService } from './services/tax-rules-manager-headers.service';

const pages = [
  UsersPageComponent,
  ClientsPageComponent,
  SecurityTypesPageComponent,
  AdminDashboardPageComponent,
  EntityTypesPageComponent,
  AdminTabsPageComponent,
  ResidencyJurisdictionsPageComponent,
  InvestmentJurisdictionsPageComponent,
  InternalUsersPageComponent,
  ExternalUsersPageComponent,
  GeneralRatesRuleEnginePageComponent,
  ResidencyJurisdictionsPageComponent,
  InvestmentJurisdictionsPageComponent,
  AssignClientComponent,
  AssignCountryMaterialComponent,
  RulesManagerPageComponent,
];

@NgModule({
  declarations: [
    AdminPrimeGridComponent,
    AdminExplanationEditorComponent,
    EntityTypesGridComponent,
    ClientsGridComponent,
    UpsertEntityTypeComponent,
    UpsertClientComponent,
    InternalUsersGridComponent,
    ExternalUsersGridComponent,
    UpsertInternalUserComponent,
    UpsertExternalUserComponent,
    ResidencyJurisdictionsGridComponent,
    UpsertResidencyJurisdictionComponent,
    InvestmentJurisdictionsGridComponent,
    UpsertInvestmentJurisdictionComponent,
    SecurityTypesGridComponent,
    UpsertSecurityTypeComponent,
    GeneralRatesRuleEngineGridComponent,
    UpsertGeneralRatesRuleEngineComponent,
    ExportCountriesInformationModalComponent,
    ExportTaxRatesValuesModalComponent,
    TransactionTypeCellComponent,
    UserEngagementsCellComponent,
    UserEngagementsDrawerComponent,
    ...pages,
  ],
  imports: [
    SearchModule,
    CommonModule,
    SharedModule,
    AdminRoutingModule,
    TabsModule,
    FieldModule,
    ModalModule,
    ReactiveFormsModule,
    CheckboxModule,
    PrimeGridFiltersModule,
    GridModule,
    RichEditorModule,
  ],
  providers: [TaxPoliciesManagerService, TaxRulesManagerHeadersService],
})
export class AdminModule {}
